import {EnumTypes} from './EnumTypes/PageEnumTypes';
import {EnumTypes as UserEnumTypes} from './EnumTypes/UserEnumTypes';
import {ActiveType} from './EnumTypes/ContractEnumTypes';
import * as AlertEnumTypes from './EnumTypes/AlertEnumTypes';
import * as VehicleEnumTypes from './EnumTypes/VehicleEnumTypes';
import * as FormsEnumTypes from './EnumTypes/FormsEnumTypes';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as Types from './ViewManagementModel';
import {EnumTypes as TerminalInstallationEnumTypes} from './EnumTypes/TerminalInstallationEnumTypes';
import i18n from './../Translations/_i18n';
import moment from 'moment';
import {TurnOffReason} from "Models/EnumTypes/TurnOffReasonEnumTypes";

export const PageUrl = new Map<EnumTypes.Page, string>([
    // [EnumTypes.Page.HOME, '/'],
    [EnumTypes.Page.MAP, '/'],
    [EnumTypes.Page.ZONES, '/zones'],
    [EnumTypes.Page.FLEET, '/fleet'],
    [EnumTypes.Page.CONTRACTORS, '/contractors'],
    [EnumTypes.Page.USERS, '/users'],
    [EnumTypes.Page.MESSAGES, '/messages'],
    [EnumTypes.Page.SETTINGS, '/settings'],
    [EnumTypes.Page.CARRAPORT, '/raports/vehicle'],
    [EnumTypes.Page.INSTALLATION_REPORT, '/raports/installation'],
    [EnumTypes.Page.ACTIVE_TERMINALS_REPORT, '/raports/active-terminals'],
    [EnumTypes.Page.VEHICLES_STATE_REPORT, '/raports/vehicles-state'],
    [EnumTypes.Page.FLEETRAPORT, '/raports/fleet'],
    [EnumTypes.Page.DRIVERRAPORT, '/raports/driver'],
    [EnumTypes.Page.MANUAL, '/manual'],
    [EnumTypes.Page.LANGUAGES, ''],
    [EnumTypes.Page.LOGIN, '/'],
    [EnumTypes.Page.REGISTER, '/register'],
    [EnumTypes.Page.FORGOT_PASSWORD, '/password-reset'],
    [EnumTypes.Page.FORGOT_PASSWORD_CONFIRM, '/password/reset/:token'],
    [EnumTypes.Page.ACTIVATE_USER_ACCOUNT_COMPLETE, '/register/activate/:token'],
    [EnumTypes.Page.PASSWORD_MANAGEMENT, '/account/manage-password'],
    [EnumTypes.Page.LOGOUT, ''],
    [EnumTypes.Page.USER_MANAGEMENT, '/users-management'],
    [EnumTypes.Page.CARS_MANAGEMENT, '/cars'],
    [EnumTypes.Page.ALERTS, '/alerts'],
    [EnumTypes.Page.TERMINAL_INSTALLATION, '/terminal-installation'],
    [EnumTypes.Page.COLLISION, '/collision'],
    [EnumTypes.Page.COLLISION_WITH_TOKEN, '/collision/token'],
    [EnumTypes.Page.CAR_ROUTE_VIEWER, '/car-route-viewer'],
    [EnumTypes.Page.CONTRACT_MANAGEMENT, '/contract'],
    [EnumTypes.Page.CONTRACT_EDIT_DATE, '/contract/:contractId/change-off-date'],
]);

export const PageUrlReverse = new Map<string, EnumTypes.Page>([
    // ['/', EnumTypes.Page.HOME],
    ['/', EnumTypes.Page.MAP],
    ['/zones', EnumTypes.Page.ZONES],
    ['/fleet', EnumTypes.Page.FLEET],
    ['/contractors', EnumTypes.Page.CONTRACTORS],
    ['/users', EnumTypes.Page.USERS],
    ['/messages', EnumTypes.Page.USERS],
    ['/settings', EnumTypes.Page.SETTINGS],
    ['/raports/vehicle', EnumTypes.Page.CARRAPORT],
    ['/raports/installation', EnumTypes.Page.INSTALLATION_REPORT],
    ['/raports/active-terminals', EnumTypes.Page.ACTIVE_TERMINALS_REPORT],
    ['/raports/fleet', EnumTypes.Page.FLEETRAPORT],
    ['/raports/driver', EnumTypes.Page.DRIVERRAPORT],
    ['/manual', EnumTypes.Page.MANUAL],
    ['/users-management', EnumTypes.Page.USER_MANAGEMENT],
    ['/cars', EnumTypes.Page.CARS_MANAGEMENT],
    ['', EnumTypes.Page.LANGUAGES],
    ['/alerts', EnumTypes.Page.ALERTS],
    ['/raports', EnumTypes.Page.CARRAPORT]
]);

export const LanguageCountryCodes = new Map<EnumTypes.Languages, string>([
    [EnumTypes.Languages.PL, 'pl'],
    [EnumTypes.Languages.EN, 'en'],
    [EnumTypes.Languages.ES, 'es'],
    [EnumTypes.Languages.PT, 'pt']
]);

export const LanguageCountryCodesReverse = new Map<string, EnumTypes.Languages>([
    ['pl', EnumTypes.Languages.PL],
    ['en', EnumTypes.Languages.EN],
    ['es', EnumTypes.Languages.ES],
    ['pt', EnumTypes.Languages.PT]
]);

export const PageDetails = new Map<EnumTypes.Page, Types.Page>([
    [EnumTypes.Page.HOME, {
        title: EnumTypes.Page.HOME,
        url: PageUrl.get(EnumTypes.Page.HOME),
        iconSrc: '/images/icons/home.svg'
    }],
    [EnumTypes.Page.MAP, {
        title: EnumTypes.Page.MAP,
        url: PageUrl.get(EnumTypes.Page.MAP),
        iconSrc: '/images/icons/map.svg'
    }],
    [EnumTypes.Page.ZONES, {
        title: EnumTypes.Page.ZONES,
        url: PageUrl.get(EnumTypes.Page.ZONES),
        iconSrc: '/images/icons/zones.svg'
    }],
    [EnumTypes.Page.FLEET, {
        title: EnumTypes.Page.FLEET,
        url: PageUrl.get(EnumTypes.Page.FLEET),
        iconSrc: '/images/icons/fleet.svg'
    }],
    [EnumTypes.Page.CONTRACTORS, {
        title: EnumTypes.Page.CONTRACTORS,
        url: PageUrl.get(EnumTypes.Page.CONTRACTORS),
        iconSrc: '/images/icons/contractors.svg'
    }],
    [EnumTypes.Page.USERS, {
        title: EnumTypes.Page.USERS,
        url: PageUrl.get(EnumTypes.Page.USERS),
        iconSrc: '/images/icons/account.svg'
    }],
    [EnumTypes.Page.MESSAGES, {
        title: EnumTypes.Page.MESSAGES,
        url: PageUrl.get(EnumTypes.Page.MESSAGES),
        iconSrc: '/images/icons/messages.svg'
    }],
    [EnumTypes.Page.SETTINGS, {
        title: EnumTypes.Page.SETTINGS,
        url: PageUrl.get(EnumTypes.Page.SETTINGS),
        iconSrc: '/images/icons/settings.svg'
    }],
    [EnumTypes.Page.CARRAPORT, {
        title: EnumTypes.Page.CARRAPORT,
        url: PageUrl.get(EnumTypes.Page.CARRAPORT),
        iconSrc: '/images/icons/car.svg'
    }],
    [EnumTypes.Page.INSTALLATION_REPORT, {
        title: EnumTypes.Page.INSTALLATION_REPORT,
        url: PageUrl.get(EnumTypes.Page.INSTALLATION_REPORT),
        iconSrc: '/images/icons/driver.svg'
    }],
    [EnumTypes.Page.ACTIVE_TERMINALS_REPORT, {
        title: EnumTypes.Page.ACTIVE_TERMINALS_REPORT,
        url: PageUrl.get(EnumTypes.Page.ACTIVE_TERMINALS_REPORT),
        iconSrc: '/images/icons/time.svg'
    }],
    [EnumTypes.Page.VEHICLES_STATE_REPORT, {
        title: EnumTypes.Page.VEHICLES_STATE_REPORT,
        url: PageUrl.get(EnumTypes.Page.VEHICLES_STATE_REPORT),
        iconSrc: '/images/icons/type_car.svg'
    }],
    [EnumTypes.Page.FLEETRAPORT, {
        title: EnumTypes.Page.FLEETRAPORT,
        url: PageUrl.get(EnumTypes.Page.FLEETRAPORT),
        iconSrc: '/images/icons/fleet.svg'
    }],
    [EnumTypes.Page.DRIVERRAPORT, {
        title: EnumTypes.Page.DRIVERRAPORT,
        url: PageUrl.get(EnumTypes.Page.DRIVERRAPORT),
        iconSrc: '/images/icons/driver.svg'
    }],
    [EnumTypes.Page.MANUAL, {
        title: EnumTypes.Page.MANUAL,
        url: PageUrl.get(EnumTypes.Page.MANUAL),
        iconSrc: '/images/icons/manual.svg'
    }],
    [EnumTypes.Page.LANGUAGES, {
        title: EnumTypes.Page.LANGUAGES,
        url: PageUrl.get(EnumTypes.Page.LANGUAGES),
        iconSrc: '/images/icons/countries/republic-of-poland.svg'
    }],
    [EnumTypes.Page.LOGIN, {title: EnumTypes.Page.LOGIN, url: PageUrl.get(EnumTypes.Page.LOGIN)}],
    [EnumTypes.Page.REGISTER, {title: EnumTypes.Page.REGISTER, url: PageUrl.get(EnumTypes.Page.REGISTER)}],
    [EnumTypes.Page.FORGOT_PASSWORD, {
        title: EnumTypes.Page.FORGOT_PASSWORD,
        url: PageUrl.get(EnumTypes.Page.FORGOT_PASSWORD)
    }],
    [EnumTypes.Page.FORGOT_PASSWORD_CONFIRM, {
        title: EnumTypes.Page.FORGOT_PASSWORD_CONFIRM,
        url: PageUrl.get(EnumTypes.Page.FORGOT_PASSWORD_CONFIRM)
    }],
    [EnumTypes.Page.ACTIVATE_USER_ACCOUNT_COMPLETE, {
        title: EnumTypes.Page.ACTIVATE_USER_ACCOUNT_COMPLETE,
        url: PageUrl.get(EnumTypes.Page.ACTIVATE_USER_ACCOUNT_COMPLETE)
    }],
    [EnumTypes.Page.PASSWORD_MANAGEMENT, {
        title: EnumTypes.Page.PASSWORD_MANAGEMENT,
        url: PageUrl.get(EnumTypes.Page.PASSWORD_MANAGEMENT),
        iconSrc: '/images/icons/gas-station.svg'
    }],
    [EnumTypes.Page.LOGOUT, {
        title: EnumTypes.Page.LOGOUT,
        url: PageUrl.get(EnumTypes.Page.LOGOUT),
        iconSrc: '/images/icons/logout.svg'
    }],
    [EnumTypes.Page.USER_MANAGEMENT, {
        title: EnumTypes.Page.USER_MANAGEMENT,
        url: PageUrl.get(EnumTypes.Page.USER_MANAGEMENT),
        iconSrc: '/images/icons/car_driver.svg'
    }],
    [EnumTypes.Page.CARS_MANAGEMENT, {
        title: EnumTypes.Page.CARS_MANAGEMENT,
        url: PageUrl.get(EnumTypes.Page.CARS_MANAGEMENT),
        iconSrc: '/images/icons/fleet.svg'
    }],
    [EnumTypes.Page.ALERTS, {
        title: EnumTypes.Page.ALERTS,
        url: PageUrl.get(EnumTypes.Page.ALERTS),
        iconSrc: '/images/icons/alert-bell.svg'
    }],
    [EnumTypes.Page.TERMINAL_INSTALLATION, {
        title: EnumTypes.Page.TERMINAL_INSTALLATION,
        url: PageUrl.get(EnumTypes.Page.TERMINAL_INSTALLATION),
        iconSrc: '/images/icons/terminal-installation.svg'
    }],
    [EnumTypes.Page.COLLISION, {
        title: EnumTypes.Page.COLLISION,
        url: PageUrl.get(EnumTypes.Page.COLLISION),
        iconSrc: '/images/icons/terminal-installation.svg'
    }],
    [EnumTypes.Page.CONTRACT_MANAGEMENT, {
        title: EnumTypes.Page.CONTRACT_MANAGEMENT,
        url: PageUrl.get(EnumTypes.Page.CONTRACT_MANAGEMENT),
        iconSrc: '/images/icons/manual.svg'
    }],
    [EnumTypes.Page.CONTRACT_EDIT_DATE, {
        title: EnumTypes.Page.CONTRACT_EDIT_DATE,
        url: PageUrl.get(EnumTypes.Page.CONTRACT_EDIT_DATE),
        iconSrc: '/images/icons/calendar_blue.svg'
    }]
]);

export const LanguagesDetails = new Map<EnumTypes.Languages, Types.LanguageDetails>([
    [EnumTypes.Languages.PL, {
        title: EnumTypes.Languages.PL,
        iconSrc: '/images/icons/countries/republic-of-poland.svg',
        countryCode: LanguageCountryCodes.get(EnumTypes.Languages.PL)
    }],
    [EnumTypes.Languages.EN, {
        title: EnumTypes.Languages.EN,
        iconSrc: '/images/icons/countries/united-kingdom.svg',
        countryCode: LanguageCountryCodes.get(EnumTypes.Languages.EN)
    }],
    [EnumTypes.Languages.ES, {
        title: EnumTypes.Languages.ES,
        iconSrc: '/images/icons/countries/croatia.svg',
        countryCode: LanguageCountryCodes.get(EnumTypes.Languages.ES)
    }],
    [EnumTypes.Languages.PT, {
        title: EnumTypes.Languages.PT,
        iconSrc: '/images/icons/countries/croatia.svg',
        countryCode: LanguageCountryCodes.get(EnumTypes.Languages.PT)
    }]
]);

export const LanguagesMenu: Array<EnumTypes.Languages> = [
    EnumTypes.Languages.PL,
    EnumTypes.Languages.EN
    // EnumTypes.Languages.ES, EnumTypes.Languages.PT
];

export const MainMenu: Array<EnumTypes.Page> = [
    // EnumTypes.Page.HOME,
    EnumTypes.Page.MAP,
    EnumTypes.Page.ZONES,
    EnumTypes.Page.FLEET,
    EnumTypes.Page.ALERTS
    // EnumTypes.Page.CONTRACTORS,
    // EnumTypes.Page.USERS,
    // EnumTypes.Page.MESSAGES
    // EnumTypes.Page.SETTINGS
];

export const ExternalMenu = [
  EnumTypes.Page.TERMINAL_INSTALLATION,
]

export const AdminMenu: Array<EnumTypes.Page> = [
    EnumTypes.Page.USER_MANAGEMENT,
    EnumTypes.Page.TERMINAL_INSTALLATION,
    EnumTypes.Page.CARS_MANAGEMENT,
    EnumTypes.Page.CONTRACT_MANAGEMENT
];

export const AccountMenu: Array<EnumTypes.Page> = [
    EnumTypes.Page.PASSWORD_MANAGEMENT,
    EnumTypes.Page.LOGOUT
];

export const ReportMenu: Array<EnumTypes.Page> = [
    EnumTypes.Page.CARRAPORT,
    EnumTypes.Page.INSTALLATION_REPORT,
    EnumTypes.Page.ACTIVE_TERMINALS_REPORT,
    EnumTypes.Page.VEHICLES_STATE_REPORT,
    EnumTypes.Page.COLLISION
    // EnumTypes.Page.FLEETRAPORT, EnumTypes.Page.DRIVERRAPORT
];

export const BottomMenu: Array<EnumTypes.Page> = [
    // EnumTypes.Page.MANUAL,
    EnumTypes.Page.LANGUAGES
];

export const CarStatusArray: Array<VehicleEnumTypes.VehicleSpeedEnum> = [
    VehicleEnumTypes.VehicleSpeedEnum.RED,
    VehicleEnumTypes.VehicleSpeedEnum.YELLOW,
    VehicleEnumTypes.VehicleSpeedEnum.GREEN,
    VehicleEnumTypes.VehicleSpeedEnum.GREY
];

export const SpeedLimitCssClass = new Map<VehicleEnumTypes.VehicleSpeedEnum, string>([
    [VehicleEnumTypes.VehicleSpeedEnum.GREY, ''],
    [VehicleEnumTypes.VehicleSpeedEnum.YELLOW, 'carDetailsComposite__carspeed-yellow'],
    [VehicleEnumTypes.VehicleSpeedEnum.RED, 'carDetailsComposite__carspeed-red'],
    [VehicleEnumTypes.VehicleSpeedEnum.GREEN, 'carDetailsComposite__carspeed-green']
]);

export const SpeedLimitRoadImage = new Map<VehicleEnumTypes.VehicleSpeedEnum, string>([
    [VehicleEnumTypes.VehicleSpeedEnum.GREY, '/images/icons/car_details/road_stop.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.YELLOW, '/images/icons/car_details/road_yellow.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.RED, '/images/icons/car_details/road_red.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.GREEN, '/images/icons/car_details/road_green.svg']
    // [VehicleEnumTypes.VehicleSpeedEnum.TURNED_OFF, '/images/icons/car_details/road_stop.svg']
]);

export const SpeedometerImage = new Map<VehicleEnumTypes.VehicleSpeedEnum, string>([
    [VehicleEnumTypes.VehicleSpeedEnum.GREY, '/images/icons/car_details/speed_stop.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.YELLOW, '/images/icons/car_details/speed_yellow.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.RED, '/images/icons/car_details/speed_red.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.GREEN, '/images/icons/car_details/speed_green.svg']
]);

export const CarCategoryImage = new Map<VehicleEnumTypes.CarCategory, string>([
    [VehicleEnumTypes.CarCategory.PASSENGER_CAR, '/images/icons/car_details/passenger_car.svg'],
    [VehicleEnumTypes.CarCategory.TRUCK, '/images/icons/car_details/truck.svg'],
    [VehicleEnumTypes.CarCategory.VAN, '/images/icons/car_details/van.svg'],
    [VehicleEnumTypes.CarCategory.MACHINE, '/images/icons/car_details/machine.svg'],
    [VehicleEnumTypes.CarCategory.SEMI_TRAILER, '/images/icons/car_details/truck.svg']
]);

export const CarCategoryImageNoShadow = new Map<VehicleEnumTypes.CarCategory, string>([
    [VehicleEnumTypes.CarCategory.PASSENGER_CAR, '/images/icons/car_marker_icons/car_.svg'],
    [VehicleEnumTypes.CarCategory.TRUCK, '/images/icons/car_marker_icons/truck_.svg'],
    [VehicleEnumTypes.CarCategory.VAN, '/images/icons/car_marker_icons/van_.svg']
]);

export const TurnedOffCarCategoryImage = new Map<VehicleEnumTypes.CarCategory, string>([
    [VehicleEnumTypes.CarCategory.PASSENGER_CAR, '/images/icons/car_details/passenger_car_stop.svg'],
    [VehicleEnumTypes.CarCategory.TRUCK, '/images/icons/car_details/truck_stop.svg'],
    [VehicleEnumTypes.CarCategory.VAN, '/images/icons/car_details/van_stop.svg'],
    [VehicleEnumTypes.CarCategory.SEMI_TRAILER, '/images/icons/car_marker_icons/semi_trailer_.svg'],
    [VehicleEnumTypes.CarCategory.MACHINE, '/images/icons/car_marker_icons/machine_.svg']
]);

export const SpeedLimitMapIcon = new Map<VehicleEnumTypes.VehicleSpeedEnum, string>([
    [VehicleEnumTypes.VehicleSpeedEnum.GREY, '/images/icons/car_marker.png'],
    [VehicleEnumTypes.VehicleSpeedEnum.YELLOW, '/images/icons/car_marker_yellow.png'],
    [VehicleEnumTypes.VehicleSpeedEnum.RED, '/images/icons/car_marker_red.png'],
    [VehicleEnumTypes.VehicleSpeedEnum.GREEN, '/images/icons/car_marker_green.png']
]);

export const VehicleSpeedIconsReverse = new Map<string, VehiclesModule.Types.VehicleSpeedReverse>([
    ['/images/icons/car_details/passenger_car_marker.svg', {
        carCategory: VehicleEnumTypes.CarCategory.PASSENGER_CAR,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.GREY,
        value: 0
    }],
    ['/images/icons/car_marker_icons/passenger_car_green.svg', {
        carCategory: VehicleEnumTypes.CarCategory.PASSENGER_CAR,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.GREEN,
        value: 1
    }],
    ['/images/icons/car_marker_icons/passenger_car_yellow.svg', {
        carCategory: VehicleEnumTypes.CarCategory.PASSENGER_CAR,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.YELLOW,
        value: 2
    }],
    ['/images/icons/car_marker_icons/passenger_car_red.svg', {
        carCategory: VehicleEnumTypes.CarCategory.PASSENGER_CAR,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.RED,
        value: 3
    }],
    ['/images/icons/car_details/truck_marker.svg', {
        carCategory: VehicleEnumTypes.CarCategory.TRUCK,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.GREY,
        value: 0
    }],
    ['/images/icons/car_marker_icons/truck_green.svg', {
        carCategory: VehicleEnumTypes.CarCategory.TRUCK,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.GREEN,
        value: 1
    }],
    ['/images/icons/car_marker_icons/truck_yellow.svg', {
        carCategory: VehicleEnumTypes.CarCategory.TRUCK,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.YELLOW,
        value: 2
    }],
    ['/images/icons/car_marker_icons/truck_red.svg', {
        carCategory: VehicleEnumTypes.CarCategory.TRUCK,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.RED,
        value: 3
    }],
    ['/images/icons/car_details/van_marker.svg', {
        carCategory: VehicleEnumTypes.CarCategory.VAN,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.GREY,
        value: 0
    }],
    ['/images/icons/car_marker_icons/van_green.svg', {
        carCategory: VehicleEnumTypes.CarCategory.VAN,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.GREEN,
        value: 1
    }],
    ['/images/icons/car_marker_icons/van_yellow.svg', {
        carCategory: VehicleEnumTypes.CarCategory.VAN,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.YELLOW,
        value: 2
    }],
    ['/images/icons/car_marker_icons/van_red.svg', {
        carCategory: VehicleEnumTypes.CarCategory.VAN,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.RED,
        value: 3
    }],
    ['/images/icons/car_details/machine_marker.svg', {
        carCategory: VehicleEnumTypes.CarCategory.MACHINE,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.GREY,
        value: 0
    }],
    ['/images/icons/car_marker_icons/machine_green.svg', {
        carCategory: VehicleEnumTypes.CarCategory.MACHINE,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.GREEN,
        value: 1
    }],
    ['/images/icons/car_marker_icons/machine_yellow.svg', {
        carCategory: VehicleEnumTypes.CarCategory.MACHINE,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.YELLOW,
        value: 2
    }],
    ['/images/icons/car_marker_icons/machine_red.svg', {
        carCategory: VehicleEnumTypes.CarCategory.MACHINE,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.RED,
        value: 3
    }],
    ['/images/icons/car_details/semi_trailer_marker.svg', {
        carCategory: VehicleEnumTypes.CarCategory.SEMI_TRAILER,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.GREY,
        value: 0
    }],
    ['/images/icons/car_marker_icons/semi_trailer_green.svg', {
        carCategory: VehicleEnumTypes.CarCategory.SEMI_TRAILER,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.GREEN,
        value: 1
    }],
    ['/images/icons/car_marker_icons/semi_trailer_yellow.svg', {
        carCategory: VehicleEnumTypes.CarCategory.SEMI_TRAILER,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.YELLOW,
        value: 2
    }],
    ['/images/icons/car_marker_icons/semi_trailer_red.svg', {
        carCategory: VehicleEnumTypes.CarCategory.SEMI_TRAILER,
        vehicleSpeedEnum: VehicleEnumTypes.VehicleSpeedEnum.RED,
        value: 3
    }]
]);
export const VehicleSpeedEnumValueDictionary = new Map<number, VehicleEnumTypes.VehicleSpeedEnum>([
    [0, VehicleEnumTypes.VehicleSpeedEnum.GREY],
    [1, VehicleEnumTypes.VehicleSpeedEnum.GREEN],
    [2, VehicleEnumTypes.VehicleSpeedEnum.YELLOW],
    [3, VehicleEnumTypes.VehicleSpeedEnum.RED]
]);
export const PassengerCarSpeedIcons = new Map<VehicleEnumTypes.VehicleSpeedEnum, string>([
    [VehicleEnumTypes.VehicleSpeedEnum.GREY, '/images/icons/car_details/passenger_car_marker.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.YELLOW, '/images/icons/car_marker_icons/passenger_car_yellow.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.RED, '/images/icons/car_marker_icons/passenger_car_red.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.GREEN, '/images/icons/car_marker_icons/passenger_car_green.svg']
]);
export const MachineSpeedIcons = new Map<VehicleEnumTypes.VehicleSpeedEnum, string>([
    [VehicleEnumTypes.VehicleSpeedEnum.GREY, '/images/icons/car_details/machine_.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.YELLOW, '/images/icons/car_marker_icons/machine_yellow.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.RED, '/images/icons/car_marker_icons/machine_red.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.GREEN, '/images/icons/car_marker_icons/machine_green.svg']
]);
export const SemiTrailerSpeedIcons = new Map<VehicleEnumTypes.VehicleSpeedEnum, string>([
    [VehicleEnumTypes.VehicleSpeedEnum.GREY, '/images/icons/car_details/semi_trailer_.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.YELLOW, '/images/icons/car_marker_icons/semi_trailer_yellow.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.RED, '/images/icons/car_marker_icons/semi_trailer_red.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.GREEN, '/images/icons/car_marker_icons/semi_trailer_green.svg']
]);
export const TruckSpeedIcons = new Map<VehicleEnumTypes.VehicleSpeedEnum, string>([
    [VehicleEnumTypes.VehicleSpeedEnum.GREY, '/images/icons/car_details/truck_marker.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.YELLOW, '/images/icons/car_marker_icons/truck_yellow.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.RED, '/images/icons/car_marker_icons/truck_red.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.GREEN, '/images/icons/car_marker_icons/truck_green.svg']
]);

export const VanSpeedIcons = new Map<VehicleEnumTypes.VehicleSpeedEnum, string>([
    [VehicleEnumTypes.VehicleSpeedEnum.GREY, '/images/icons/car_details/van_marker.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.YELLOW, '/images/icons/car_marker_icons/van_yellow.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.RED, '/images/icons/car_marker_icons/van_red.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.GREEN, '/images/icons/car_marker_icons/van_green.svg']
]);

export const CarStatusTableFilters = new Map<VehicleEnumTypes.VehicleSpeedEnum, string>([
    [undefined, '/images/icons/table_filters/car_filter_default.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.GREY, '/images/icons/table_filters/car_filter_default.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.YELLOW, '/images/icons/table_filters/car_filter_yellow.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.RED, '/images/icons/table_filters/car_filter_red.svg'],
    [VehicleEnumTypes.VehicleSpeedEnum.GREEN, '/images/icons/table_filters/car_filter_green.svg']
]);

export const CarCategoryTableFilters = new Map<VehicleEnumTypes.CarCategory, string>([
    [VehicleEnumTypes.CarCategory.PASSENGER_CAR, '/images/icons/table_filters/car_filter_default.svg'],
    [VehicleEnumTypes.CarCategory.TRUCK, '/images/icons/table_filters/truck_filter.svg'],
    [VehicleEnumTypes.CarCategory.VAN, '/images/icons/table_filters/van_filter.svg'],
    [VehicleEnumTypes.CarCategory.MACHINE, '/images/icons/table_filters/machine_filter.svg'],
    [VehicleEnumTypes.CarCategory.SEMI_TRAILER, '/images/icons/table_filters/semi_trailer_filter.svg']
]);
export const ZoneTypeIcons = new Map<AlertEnumTypes.DomainOfIntrestType, string>([
    [AlertEnumTypes.DomainOfIntrestType.POI, '/images/icons/poi_marker.svg'],
    [AlertEnumTypes.DomainOfIntrestType.AREA, '/images/icons/strefa.svg']
]);
export const RoleNameDictionaryMap = new Map<UserEnumTypes.RoleName, string>([
    [UserEnumTypes.RoleName.ADMIN, i18n.t(`dictionary:${UserEnumTypes.RoleName.ADMIN}`)],
    [UserEnumTypes.RoleName.FLEET_OWNER, i18n.t(`dictionary:${UserEnumTypes.RoleName.FLEET_OWNER}`)]
]);

export const AlertConditionDictionaryMap = new Map<AlertEnumTypes.AlertCondition, string>([
    [AlertEnumTypes.AlertCondition.ENTERING_AREA, 'Wjazd do strefy'],
    [AlertEnumTypes.AlertCondition.LEAVING_AREA, 'Wyjazd ze strefy'],
    [AlertEnumTypes.AlertCondition.SPEEDING, 'Przekroczenie prędkości']
]);

export const PriorityIcons = new Map<AlertEnumTypes.Priority, string>([
    [AlertEnumTypes.Priority.LOW, '/images/icons/priority_blue.svg'],
    [AlertEnumTypes.Priority.MEDIUM, '/images/icons/priority_yellow.svg'],
    [AlertEnumTypes.Priority.HIGH, '/images/icons/priority_red.svg']
]);

export const UserStatusArray: Array<UserEnumTypes.Status> = [UserEnumTypes.Status.ACTIVE, UserEnumTypes.Status.BLOCKED, UserEnumTypes.Status.NOT_ACTIVE];
// export const UserStatusIcon = new Map<UserEnumTypes.Status, string>([
//     [UserEnumTypes.Status.ACTIVE, '/images/icons/save.svg'],
//     [UserEnumTypes.Status.BLOCKED, '/images/icons/block_active.svg'],
//     [UserEnumTypes.Status.NOT_ACTIVE, '/images/icons/no_active.svg'],
// ]);

export const RoleNameArray: Array<UserEnumTypes.RoleName> = [
  UserEnumTypes.RoleName.ADMIN,
  UserEnumTypes.RoleName.FLEET_OWNER,
  UserEnumTypes.RoleName.TECHNICIAN,
  UserEnumTypes.RoleName.EXTERNAL,
];

export const CarCategoryArray: Array<VehicleEnumTypes.CarCategory> = [
    VehicleEnumTypes.CarCategory.PASSENGER_CAR,
    VehicleEnumTypes.CarCategory.TRUCK,
    VehicleEnumTypes.CarCategory.VAN,
    // Usunięte w zw. z #43858
    // VehicleEnumTypes.CarCategory.MACHINE,
    // VehicleEnumTypes.CarCategory.SEMI_TRAILER
];

export const PriorityArray: Array<AlertEnumTypes.Priority> = [AlertEnumTypes.Priority.LOW, AlertEnumTypes.Priority.MEDIUM, AlertEnumTypes.Priority.HIGH];

export const AlertConditionArray: Array<AlertEnumTypes.AlertCondition> = [
    AlertEnumTypes.AlertCondition.SPEEDING,
    AlertEnumTypes.AlertCondition.ENTERING_AREA,
    AlertEnumTypes.AlertCondition.LEAVING_AREA
];

export const TurnOffReasonArray: Array<TurnOffReason> = [
    TurnOffReason.CAR_BOUGHT_BY_CLIENT,
    TurnOffReason.CONTRACT_CANCELLED_WITHOUT_PURCHASE,
    TurnOffReason.DEBT_COLLECTION_REPOSSESSION,
    TurnOffReason.OTHER,
    TurnOffReason.THEFT,
    TurnOffReason.TOTAL_LOSS,
];

export const TerminalInstalationStatusIcon = new Map<TerminalInstallationEnumTypes.Status, string>([
    [TerminalInstallationEnumTypes.Status.NEW, '/images/icons/status_new.svg'],
    [TerminalInstallationEnumTypes.Status.INSTALLATION_DATE_CONFIRMED, '/images/icons/status_progres.svg'],
    [TerminalInstallationEnumTypes.Status.INSTALLATION_FINISHED, '/images/icons/status_succes.svg'],
    [TerminalInstallationEnumTypes.Status.CANCELLED, '/images/icons/status_cancel.svg'],
    [TerminalInstallationEnumTypes.Status.INSTALLATION_CONFIRMED, '/images/icons/flash.svg']
]);

export const UserStatusIcon = new Map<UserEnumTypes.Status, string>([
    [UserEnumTypes.Status.ACTIVE, '/images/icons/active_user.svg'],
    [UserEnumTypes.Status.NOT_ACTIVE, '/images/icons/block_noactive.svg'],
    [UserEnumTypes.Status.BLOCKED, '/images/icons/block_active.svg']
]);

export function GenerateList(arrayToGenerateList: Array<any>, translationName = 'dictionary') {
    const roleNameList: Array<Types.OptionsElement> = [];
    arrayToGenerateList.forEach((e, i) => {
        roleNameList.push({
            value: e,
            label: i18n.t(`${translationName}:${e}`)
        });
    });
    return roleNameList;
}

export type DateRangeValue = {
    startDate: moment.Moment;
    endDate: moment.Moment;
    enum?: FormsEnumTypes.DateRange;
};
export const DateRangeValuesMap = new Map<FormsEnumTypes.DateRange, DateRangeValue>([
    [FormsEnumTypes.DateRange.TODAY, {startDate: moment().startOf('day'), endDate: moment()}],
    [
        FormsEnumTypes.DateRange.YESTERDAY,
        {
            startDate: moment()
                .subtract(1, 'days')
                .startOf('day'),
            endDate: moment()
                .subtract(1, 'days')
                .endOf('day')
        }
    ],
    [FormsEnumTypes.DateRange.THIS_WEEK, {startDate: moment().startOf('isoWeek'), endDate: moment()}],
    [
        FormsEnumTypes.DateRange.LAST_WEEK,
        {
            startDate: moment()
                .subtract(1, 'weeks')
                .startOf('isoWeek'),
            endDate: moment()
                .subtract(1, 'weeks')
                .endOf('isoWeek')
        }
    ],
    [FormsEnumTypes.DateRange.THIS_MONTH, {startDate: moment().startOf('month'), endDate: moment()}],
    [
        FormsEnumTypes.DateRange.LAST_MONTH,
        {
            startDate: moment()
                .subtract(1, 'months')
                .startOf('month'),
            endDate: moment()
                .subtract(1, 'months')
                .endOf('month')
        }
    ],
    [FormsEnumTypes.DateRange.THIS_YEAR, {startDate: moment().startOf('year'), endDate: moment()}],
    [
        FormsEnumTypes.DateRange.LAST_YEAR,
        {
            startDate: moment()
                .subtract(1, 'years')
                .startOf('year'),
            endDate: moment()
                .subtract(1, 'years')
                .endOf('year')
        }
    ]
]);

export function generateDateRangesList(): Array<Types.OptionsElement> {
    const {DateRange} = FormsEnumTypes;
    const dateRangeList: Array<Types.OptionsElement> = [];
    const DateRangeEnumTypesArray: Array<FormsEnumTypes.DateRange> = [
        DateRange.TODAY,
        DateRange.YESTERDAY,
        DateRange.THIS_WEEK,
        DateRange.LAST_WEEK,
        DateRange.THIS_MONTH,
        DateRange.LAST_MONTH,
        DateRange.THIS_YEAR,
        DateRange.LAST_YEAR
    ];
    DateRangeEnumTypesArray.forEach((e, i) => {
        const value = DateRangeValuesMap.get(e);
        value.enum = e;
        dateRangeList.push({
            value,
            label: i18n.t(`dictionary:${e}`)
        });
    });

    return dateRangeList;
}



// WEBPACK FOOTER //
// ./src/Models/Dictionary.ts